import { ref } from 'vue';

export const useLoading = (initial = false) => {
    const loading = ref<boolean>(initial);

    const toggle = (nextVal?: boolean) => {
        if (typeof nextVal === 'boolean') {
            loading.value = nextVal;
        } else {
            loading.value = !loading.value;
        }
    };

    return {
        toggle,
        loading,
    };
};
